import React from 'react';

import FormPage from 'src/presentation/components/pages/shared/FormPage';
import ExternalLink from 'src/presentation/components/pages/shared/ExternalLink';
import RoutingForm from 'src/presentation/components/pages/routing/RoutingForm';
import voiceConfigResource from 'src/actions/voice/voiceConfigResource';
import { useRoutes } from 'src/presentation/components/pages/routing/hooks/useRoutes';

const dataAid = 'admin-routing-page';
const title = 'Conversation Workflow';

const description = (
  <span data-aid={dataAid + '-description'}>
    Manage channel settings for Agents in your organization.{' '}
    <ExternalLink
      data-aid={dataAid + '-help-link'}
      label="Learn about best practices"
      to="https://help.gladly.com/docs/configure-mail-routing-settings"
    />
    .
  </span>
);

const Routing = () => {
  const { item, isLoading, errors } = useRoutes();
  return (
    <FormPage
      data-aid={dataAid}
      form={RoutingForm}
      errors={errors}
      isLoading={isLoading}
      item={item}
      title={title}
      description={description}
      resetErrors={voiceConfigResource.actions.resetErrors}
    />
  );
};

export default Routing;
